import React from "react";
import MoleculeBg from "./MoleculeBg";

/**
 * Branded research-vial illustration used on product cards in place of stock
 * photography (Shift4Shop remains the source of real product imagery).
 * Deliberate, understated, on-brand — not a fabricated product photo.
 */
export default function ProductVisual({ name = "", accent = "#C8A96A", className = "", dark = true }) {
  const bg = dark ? "#1E2A44" : "#F7F4EF";
  const line = dark ? accent : "#1E2A44";
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ backgroundColor: bg }}
      aria-hidden="true"
    >
      <MoleculeBg className="absolute -right-16 -top-10 w-[70%] h-[70%]" color={line} opacity={0.16} />
      <div className="absolute inset-0 flex items-center justify-center">
        <svg width="120" height="180" viewBox="0 0 120 180" fill="none" className="transition-transform duration-700 ease-out group-hover:scale-105">
          <path d="M48 14 h24" stroke={line} strokeWidth="2" strokeLinecap="round" />
          <path d="M52 14 v10 a4 4 0 0 0 1 3 l6 8 v112 a12 12 0 0 1 -12 12 h0"
                stroke={line} strokeWidth="1.6" fill="none" />
          <path d="M68 14 v10 a4 4 0 0 1 -1 3 l-6 8 v112 a12 12 0 0 0 12 12"
                stroke={line} strokeWidth="1.6" fill="none" />
          <rect x="47" y="120" width="26" height="35" rx="2" fill={line} opacity="0.22" />
          <line x1="47" y1="112" x2="73" y2="112" stroke={line} strokeWidth="1" opacity="0.5" />
        </svg>
      </div>
      <span
        className="absolute left-5 bottom-4 text-[10px] uppercase tracking-[0.28em]"
        style={{ color: line, opacity: 0.7 }}
      >
        Research Material
      </span>
    </div>
  );
}
